export const SgpOrderStatusIdEnum = {
	DRAFT: 1,
	SENT: 2,
	INPOSTPROCESSING: 3,
	APPROVED: 4,
	WAITING_APPROVAL: 5
};
